"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeNames = exports.Types = exports.SizeNames = exports.Sizes = void 0;

var _SizeNames, _TypeNames;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sizes = {
  Small: 12,
  Medium: 16,
  Large: 24,
  // TODO(lindsey-menges): deprecate XLarge size in v7
  XLarge: 32
};
exports.Sizes = Sizes;
var SizeNames = (_SizeNames = {}, _defineProperty(_SizeNames, Sizes.Small, 'Small'), _defineProperty(_SizeNames, Sizes.Medium, 'Medium'), _defineProperty(_SizeNames, Sizes.Large, 'Large'), _defineProperty(_SizeNames, Sizes.XLarge, 'Large'), _SizeNames);
exports.SizeNames = SizeNames;
var Types = {
  Primary: 'BUTTON/PRIMARY',
  Secondary: 'BUTTON/SECONDARY',
  Tertiary: 'BUTTON/TERTIARY',
  // TODO(lindsey-menges): deprecate Pill types in v7
  PrimaryPill: 'BUTTON/PRIMARY_PILL',
  SecondaryPill: 'BUTTON/SECONDARY_PILL',
  TertiaryPill: 'BUTTON/TERTIARY_PILL'
};
exports.Types = Types;
var TypeNames = (_TypeNames = {}, _defineProperty(_TypeNames, Types.Primary, 'Primary'), _defineProperty(_TypeNames, Types.Secondary, 'Secondary'), _defineProperty(_TypeNames, Types.Tertiary, 'Tertiary'), _defineProperty(_TypeNames, Types.PrimaryPill, 'Primary'), _defineProperty(_TypeNames, Types.SecondaryPill, 'Secondary'), _defineProperty(_TypeNames, Types.TertiaryPill, 'Tertiary'), _TypeNames);
exports.TypeNames = TypeNames;